import getStore from '../store/store';
export default function getNumberOfSharingLinks() {
    var store = getStore();
    return store.sharingLinks.size;
}
//# sourceMappingURL=getNumberOfSharingLinks.js.map